import { DurationInterface, DurationPeriod } from '@vendasta/sales-orders';

export function calculateContractDurationMonths(d: DurationInterface): number {
  let months = 0;
  if (!d) {
    return months;
  }
  if (d.duration === DurationPeriod.MONTH) {
    months = d.value || 0;
  }
  if (d.duration === DurationPeriod.YEAR) {
    months = 12 * (d.value || 0);
  }
  return months;
}
